/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_ManageInputs */

const en_checkout_manage = /** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const es_checkout_manage = /** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar`)
};

const fr_checkout_manage = /** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer`)
};

const de_checkout_manage = /** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten`)
};

const id_checkout_manage = /** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola`)
};

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const ja_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const zh_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const ar_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const it_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const ru_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const pt_checkout_manage = en_checkout_manage;

/** @type {(inputs: Checkout_ManageInputs) => LocalizedString} */
const ko_checkout_manage = en_checkout_manage;

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Checkout_ManageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_manage = /** @type {((inputs?: Checkout_ManageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_ManageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_manage(inputs)
	if (locale === "es") return es_checkout_manage(inputs)
	if (locale === "fr") return fr_checkout_manage(inputs)
	if (locale === "de") return de_checkout_manage(inputs)
	if (locale === "ja") return ja_checkout_manage(inputs)
	if (locale === "zh") return zh_checkout_manage(inputs)
	if (locale === "ar") return ar_checkout_manage(inputs)
	if (locale === "id") return id_checkout_manage(inputs)
	if (locale === "it") return it_checkout_manage(inputs)
	if (locale === "ru") return ru_checkout_manage(inputs)
	if (locale === "pt") return pt_checkout_manage(inputs)
	return ko_checkout_manage(inputs)
});